<template>
  <div class="plan-row-item-neon-price">
    <div class="plan-row-item-neon-price__bundle-name">ADVENTURE {{ 1 + itemIndex }}</div>
    <div class="plan-row-item-neon-price__amount">
      {{ `$${price}` }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanRowItemNeonCardPrice',
  props: {
    plan: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    price() {
      const priceToShow = this.plan.user_receives_discount
        ? this.plan.discounted_price_cents
        : this.plan.price_cents
      return priceToShow / 100
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-row-item-neon-price {
  background-color: var(--cod-gray);
  background: url('../../assets/images/backgrounds/bl-bundle-price-bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 190px;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  position: relative;
  @include mobile {
    width: calc(100% - 80px);
    position: absolute;
    top: -57px;
    margin: unset;
  }
  @include desktop {
    top: -85px;
  }
  &__bundle-name {
    color: var(--purple-pale);
    text-align: center;
    font-size: rem(14px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(30px);
  }
  &__amount {
    color: var(--white);
    font-family: var(--font-medium);
    font-style: normal;
    font-weight: 700;
    font-size: rem(54px);
    line-height: rem(55px);
  }
}
</style>
